export default __webpack_public_path__ + "assets/images/cc6dc5ee827c5be38953c9f8b11d0afc.svg";